import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "store";
import { useForm, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, TextInput } from "ui";

import { usernamePasswordFields, usernamePasswordSchema } from "../../schema";

import POOLBAN_MAIN_IMAGE from "assets/poolban-main.png";
import { useMerchantNamePassword } from "features/login/api/username-password";
import { setLoginState } from "features/login/slice";
import {
  setToken,
  setUserID,
  setUserState,
  setUserStateDetail,
} from "features/layouts/dashboard-layout/slice";
export const UsernamePasswordForm = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const usernamePasswordQuery = useMerchantNamePassword({});
  const form = useForm<usernamePasswordFields>({
    resolver: zodResolver(usernamePasswordSchema),
  });
  const { register, formState, handleSubmit } = form;
  const submitHandler: SubmitHandler<usernamePasswordFields> = (
    values: usernamePasswordFields
  ) => {
    usernamePasswordQuery.mutate(
      {
        data: values,
      },
      {
        onSuccess: (data) => {
          dispatch(setUserState(data.data.status));
          dispatch(setUserStateDetail(data.data.statusDetail));
          dispatch(setUserID(data.data?.id));
          dispatch(setToken(data.data?.jwToken));
          if (
            data.data.status === "REGISTER" &&
            data.data.statusDetail === "NOT_CHECKED"
          ) {
            navigate("/register");
          } else if (data.data.status === "AUTHENTICATION") {
            navigate("/authentication");
          } else {
            navigate("/dashboard");
          }
          dispatch(setLoginState("phone-number"));
        },
      }
    );
  };
  return (
    <div className={"d-flex justify-content-between flex-column flex-grow-1"}>
      <form onSubmit={handleSubmit(submitHandler)}>
        <TextInput
          label={"نام کاربری"}
          error={formState.errors.username?.message}
          registration={register("username")}
          placeholder={"نام کاربری  خود را وارد کنید"}
          className="my-1"
        />
        
        <TextInput
          type="password"
          label={"رمز عبور"}
          error={formState.errors.password?.message}
          registration={register("password")}
          placeholder={"رمز عبور خود را وارد کنید"}
        />   
        <Button
          isLoading={usernamePasswordQuery.isLoading}
          isDisabled={usernamePasswordQuery.isLoading}
          className="w-100 my-3"
          type="submit"
          onClick={handleSubmit(submitHandler)}
        >
          ورود به حساب کاربری
        </Button> 
      </form>
      <div className="flex-center">
        <img
          src={POOLBAN_MAIN_IMAGE}
          alt="poolban.ir"
          style={{ maxWidth: "320px" }}
        />
      </div>
    </div>
  );
};
